import React from 'react';

const SVG = ({ style = {}, fill = '#000', width = 100, className = '', viewBox = '0 0 48 48' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox={viewBox}
    className={`svg-icon ${className || ''}`}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h48v48H0z" />
      <g transform="translate(11.684 6)">
        <path
          fill="#A5A8AB"
          stroke="#A5A8AB"
          strokeWidth=".85"
          d="M17.955 18.281c0 2.673.476 2.295 2.064 2.97l4.125.832V.748c0-.973-3.163 0-4.125 2.88-.961 2.88-2.064 11.98-2.064 14.653z"
        />
        />
        <path
          fill="#FF694B"
          stroke="#FF694B"
          strokeWidth=".85"
          d="M24.102 21.97v11.575c.001 1.092-1.094 1.978-2.449 1.982-1.408.005-2.538-.697-2.538-1.982 0-1.274 1.562-7.688 2.538-11.575.357-1.262 2.449-.925 2.449 0z"
        />
        />
        <path
          fill="#D3543A"
          d="M22.084 33.409a1.03 1.03 0 1 1 0-2.06 1.03 1.03 0 1 1 0 2.06zM22.558 27.537a1.03 1.03 0 1 1 0-2.059 1.03 1.03 0 1 1 0 2.06z"
        />
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill="#A5A8AB"
          stroke="#A5A8AB"
          strokeWidth=".5"
          id="a"
          d="M9.547.265h-1.01c-.209 0-.378.142-.378.316v13.914c0 .149 0 .394-.406.582-.405.188-.945-.17-.945-.51V.581c0-.174-.17-.316-.379-.316 0 0-1.01-.034-1.204 0-.195.035-.38.142-.38.316v13.913c0 .15-.101.395-.521.583-.374.167-.968-.17-.968-.51V.581c0-.174-.17-.316-.38-.316h-.882c-.168 0-.311.1-.34.238L.09 15.077c-.27 1.951.355 2.894 3.067 4.054.383.164.926.46 1.586.825-.716 5.082-1.917 10.152-1.917 12.211 0 2.06 1.313 3.25 2.95 3.25 1.635 0 2.924-1.19 2.924-3.25 0-2.059-1.255-7.13-1.893-12.211.601-.431 1.173-.597 1.893-1.001 1.929-1.083 2.763-2.223 2.508-4.066L9.888.503c-.03-.137-.173-.238-.34-.238z"
        ></path>
      </g>
    </g>
  </svg>
);

export default SVG;
